import type { ReactNode } from 'react'
import { Icon } from '@iconify/react'
import { useDistributorWorkspace } from '@/contexts/DistributorWorkspaceContext'
import {
  describeMyDistributorEmptyState,
} from '@/lib/my-distributor'
import { MyDistributorEmptyState } from '@/pages/SouDistribuidorPage/MyDistributorEmptyState'
import styles from './SouDistribuidorPage.module.css'

interface RequireDistributorWorkspaceProps {
  children: ReactNode
  requireActiveProgram?: boolean
}

export function RequireDistributorWorkspace({
  children,
  requireActiveProgram = false,
}: RequireDistributorWorkspaceProps) {
  const {
    programs,
    profile,
    loginContext,
    isLoading,
    error,
    reload,
    selectedProgram,
    hasWorkspaceContext,
  } = useDistributorWorkspace()

  if (isLoading) {
    return (
      <div className={styles.centered}>
        <Icon icon="mdi:loading" className={styles.spinner} />
        <span>Carregando...</span>
      </div>
    )
  }

  if (error) {
    return (
      <div className={styles.centered}>
        <Icon icon="mdi:alert-circle-outline" className={styles.errorIcon} />
        <span>{error}</span>
        <button type="button" className={styles.retryBtn} onClick={() => void reload()}>
          Tentar novamente
        </button>
      </div>
    )
  }

  if (programs.length === 0) {
    return (
      <MyDistributorEmptyState
        icon="mdi:truck-delivery-outline"
        message={describeMyDistributorEmptyState(loginContext, profile, programs)}
      />
    )
  }

  if (!hasWorkspaceContext || !selectedProgram) {
    return (
      <div className={styles.centered}>
        <Icon icon="mdi:domain" style={{ fontSize: '2rem' }} />
        <p>Selecione uma instituição no topo da página para continuar.</p>
      </div>
    )
  }

  if (requireActiveProgram && !selectedProgram.is_active) {
    return (
      <div className={styles.centered}>
        <Icon icon="mdi:pause-circle-outline" style={{ fontSize: '2rem' }} />
        <p>Seu credenciamento nesta instituição está inativo.</p>
        <p className={styles.programMeta}>Peça à instituição a reativação do perfil de distribuidor.</p>
      </div>
    )
  }

  return <>{children}</>
}
